package com.sweetlime.dungeonamigo.presentation.features.session

import androidx.compose.foundation.background
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors

// Compact inline HP tracker for DM entity rows.
// [−] [current / max] [+]  [temp badge if > 0]
@Composable
fun EntityHpTracker(
    current: Int,
    max: Int,
    temp: Int,
    onDecrement: () -> Unit,
    onIncrement: () -> Unit,
    onLongPress: () -> Unit,
) {
    val hpColor = entityHpColor(current, max)

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
    ) {
        // Minus button
        Box(
            modifier = Modifier
                .size(28.dp)
                .clip(RoundedCornerShape(6.dp))
                .background(BrandColors.SurfaceLight)
                .combinedClickable(onClick = onDecrement, onLongClick = onLongPress),
            contentAlignment = Alignment.Center,
        ) {
            Text("−", color = BrandColors.Ember, fontSize = 16.sp, fontWeight = FontWeight.Bold)
        }

        // HP display — long press opens SetHpDialog
        Box(
            modifier = Modifier
                .combinedClickable(onClick = {}, onLongClick = onLongPress),
            contentAlignment = Alignment.Center,
        ) {
            Text(
                "$current/$max",
                color = hpColor,
                fontSize = 13.sp,
                fontWeight = FontWeight.SemiBold,
            )
        }

        // Plus button
        Box(
            modifier = Modifier
                .size(28.dp)
                .clip(RoundedCornerShape(6.dp))
                .background(BrandColors.SurfaceLight)
                .combinedClickable(onClick = onIncrement, onLongClick = onLongPress),
            contentAlignment = Alignment.Center,
        ) {
            Text("+", color = BrandColors.Success, fontSize = 16.sp, fontWeight = FontWeight.Bold)
        }

        // Temp HP badge
        if (temp > 0) {
            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(8.dp))
                    .background(BrandColors.SpellBlue.copy(alpha = 0.2f))
                    .padding(horizontal = 6.dp, vertical = 2.dp),
            ) {
                Text(
                    "+$temp tmp",
                    color = BrandColors.SpellBlue,
                    fontSize = 10.sp,
                    fontWeight = FontWeight.SemiBold,
                )
            }
        }
    }
}

private fun entityHpColor(current: Int, max: Int) = when {
    max <= 0 -> BrandColors.HpFull
    current.toFloat() / max > 0.5f -> BrandColors.HpFull
    current.toFloat() / max > 0.25f -> BrandColors.HpMid
    else -> BrandColors.HpLow
}
